import type {
  Chapter,
  CourseEntityChangeStatus,
} from "@repo/app-types/entities/course";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { getChangeStatusHighlightClasses } from "./changeStatusHighlight.js";
import { ChapterItemChevronButton } from "./chapterItemChevronButton.js";
import { ChapterItemIndex } from "./chapterItemIndex.js";
import { ChapterItemTitle } from "./chapterItemTitle.js";

export interface ChapterItemSettingsContentProps {
  index: number;
  chapter: Chapter;
  changeStatus?: CourseEntityChangeStatus;
}

/** Presentational component that renders the inside of a chapter cell in a course tree UI for settings. */
export const ChapterItemSettingsContent: FC<ChapterItemSettingsContentProps> = (
  props,
) => {
  return (
    <div
      className={twMerge(
        "flex min-w-0 items-center space-x-4 px-4 py-2",
        getChangeStatusHighlightClasses(props.changeStatus),
      )}
    >
      <ChapterItemIndex index={props.index} />
      <ChapterItemTitle index={props.index} chapter={props.chapter} />
      <ChapterItemChevronButton />
    </div>
  );
};
